<template>
  <main class="w-full">
    <!-- SEARCH -->
    <section class="relative">
      <img
        src="../../assets/images/YellowPage/mining-industry.jpg"
        alt="mining"
        class="w-full"
      />

      <div class="absolute top-40 flex justify-center w-full">
        <div class="w-4/5">
          <div class="bg-white rounded px-6 py-3 space-y-5 w-2/5">
            <div class="flex border border-[#666666] rounded p-1">
              <button
                @click="toggleSearch('company')"
                class="w-52 rounded text-center p-3"
                :class="
                  selectedType === 'company'
                    ? 'bg-gold text-black'
                    : 'text-[#666666]'
                "
              >
                <font-awesome-icon
                  icon="fa-solid fa-building-columns"
                  class="mr-1"
                />
                {{ lang === "mn" ? "Байгууллага" : "Company" }}
              </button>
              <button
                @click="toggleSearch('consultant')"
                class="w-52 rounded text-center p-3"
                :class="
                  selectedType === 'consultant'
                    ? 'bg-gold text-black'
                    : 'text-[#666666]'
                "
              >
                <font-awesome-icon icon="fa-solid fa-user-tie" class="mr-1" />
                {{ lang === "mn" ? "Зөвлөх инженер" : "Consultant" }}
              </button>
            </div>

            <div class="flex items-center w-full rounded border">
              <font-awesome-icon
                icon="fa-solid fa-magnifying-glass"
                class="text-gray-300 text-lg p-3"
              />
              <input
                type="text"
                :placeholder="lang === 'mn' ? 'Хайлт' : 'Search'"
                class="w-full p-3"
                v-model="searchQuery"
              />
            </div>

            <button
              @click="findData()"
              class="w-full bg-coal rounded text-white text-center p-3 hover:bg-black"
            >
              {{ lang === "mn" ? "Хайх" : "Find" }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="flex justify-center">
      <div class="w-full xl:w-5/6 max-xl:px-3">
        <!-- NEWS -->
        <section v-if="news.length > 0" class="w-full my-10">
          <a
            href="https://miningmongolia.mn/mm/blog/8=1"
            target="_blank"
            class="flex items-center gap-3 text-black text-4xl font-bold hover:text-coal"
          >
            {{ lang === "mn" ? "Мэдээ" : "News" }}
            <font-awesome-icon
              icon="fa-solid fa-arrow-right-long"
              class="text-xl"
            />
          </a>

          <div class="flex w-full gap-10 mt-5">
            <a
              :href="`https://miningmongolia.mn/mm/detail/${news[0].id}`"
              target="_blank"
              class="w-full"
            >
              <img
                :src="news[0]?.image"
                alt="image"
                class="w-full h-[34rem] object-cover rounded"
              />
              <h3 class="text-black text-2xl font-bold line-clamp-3 mt-1.5">
                {{ lang === "mn" ? news[0].title : news[0].title_en }}
              </h3>
              <p class="flex items-center text-coal text-sm">
                <font-awesome-icon
                  icon="fa-solid fa-calendar-day"
                  class="mr-1"
                />{{ news[0].created_at }}
              </p>
              <p class="text-coal font-light text-xs line-clamp-5 mt-3">
                {{ lang === "mn" ? news[0].summary : news[0].summary_en }}
              </p>
              <p class="text-coal text-sm mt-3 hover:underline">
                {{ lang === "mn" ? "Цааш унших" : "Read more" }}
                <font-awesome-icon
                  icon="fa-solid fa-circle-chevron-right"
                  class="ml-0.5"
                />
              </p>
            </a>

            <div class="flex flex-col w-full divide-y">
              <a
                v-for="(story, index) in news.slice(1, 4)"
                :key="index"
                :href="`https://miningmongolia.mn/mm/detail/${story.id}`"
                :class="index === 0 ? 'pb-5' : 'py-5'"
              >
                <img
                  :src="story.image"
                  alt="image"
                  class="w-full h-36 object-cover rounded"
                />
                <h3 class="font-bold text-xl text-black line-clamp-2 mt-3">
                  {{ lang === "mn" ? story.title : story.title_en }}
                </h3>
                <p class="flex items-center text-coal text-xs">
                  <font-awesome-icon
                    icon="fa-solid fa-calendar-day"
                    class="mr-1"
                  />{{ story.created_at }}
                </p>
                <p class="line-clamp-3 text-gray-500 text-xs mt-3">
                  {{ lang === "mn" ? story.summary : story.summary_en }}
                </p>
                <p class="text-coal text-sm mt-1.5 hover:underline">
                  {{ lang === "mn" ? "Цааш унших" : "Read more" }}
                  <font-awesome-icon
                    icon="fa-solid fa-circle-chevron-right"
                    class="ml-0.5"
                  />
                </p>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  name: "YPHome",
  setup() {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const isLoading = ref(false);

    const selectedType = ref("company");
    const searchQuery = ref(null);
    const news = ref([]);

    const toggleSearch = (item) => {
      selectedType.value = item;
    };

    const findData = () => {};

    const fetchNews = async () => {
      isLoading.value = true;
      try {
        const response = await store.dispatch("yellow/fetchNews", lang.value);
        if (response?.data?.news) {
          news.value = response.data.news;
        } else {
          console.warn("No categories in response", response);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      } finally {
        isLoading.value = false;
      }
    };

    const checkNews = () => {
      const existingNews = store.getters["yellow/getNews"];
      if (!existingNews || existingNews.length === 0) {
        fetchNews();
      } else {
        news.value = existingNews;
      }
    };

    onMounted(() => {
      checkNews();
    });

    watch(lang, async (newLang, oldLang) => {
      if (newLang !== oldLang) {
        await fetchNews();
      }
    });

    return {
      lang,
      isLoading,
      selectedType,
      searchQuery,
      toggleSearch,
      findData,
      news,
    };
  },
};
</script>
